import React from "react";
import Button from "./Button";

type Props = {
  title?: string;
  message?: string;
  onRetry?: () => void;
};

export default function ErrorState({
  title = "Something went wrong",
  message = "We couldn't load this data. Please try again.",
  onRetry,
}: Props) {
  return (
    <div
      role="alert"
      className="rounded-card border border-alert-critical/40 bg-alert-critical/10 text-white p-6 max-w-xl mx-auto"
    >
      <h3 className="text-lg font-semibold text-alert-critical">{title}</h3>
      <p className="mt-1 text-sm text-white/80">{message}</p>
      {onRetry ? (
        <div className="mt-4">
          <Button variant="primary" size="sm" onClick={onRetry}>
            Retry
          </Button>
        </div>
      ) : null}
    </div>
  );
}
